import { makeCatalogEvent, prependCatalogName } from '@dashboard/junk-drawer/utils/eventstream';
const DEPOSITS_IMPRESSIONS_CATALOG = 'deposits_impressions';
export function linkDebitCardModalView(eventSource) {
  return depositsImpressionEvent(`${eventSource}: Link Debit Card Modal`);
}
export function linkDebitCardModalSave(eventSource) {
  return depositsImpressionEvent(`${eventSource}: Link Debit Card Modal Save`);
}
export function linkDebitCardModalCancel(eventSource) {
  return depositsImpressionEvent(`${eventSource}: Link Debit Card Modal Cancel`);
}
function depositsImpressionEvent(imp_description) {
  return makeCatalogEvent(DEPOSITS_IMPRESSIONS_CATALOG, prependCatalogName({
    imp_description
  }, DEPOSITS_IMPRESSIONS_CATALOG));
}

// CDP
export let Action = /*#__PURE__*/function (Action) {
  Action["Click"] = "Click";
  Action["View"] = "View";
  return Action;
}({});
export let Applet = /*#__PURE__*/function (Applet) {
  Applet["Balance"] = "Balance";
  Applet["Banking"] = "Banking";
  Applet["Homepage"] = "Homepage";
  Applet["Settings"] = "Settings";
  Applet["TransferSettings"] = "Transfer Settings";
  return Applet;
}({});
export let Feature = /*#__PURE__*/function (Feature) {
  Feature["DebitCardPayIn"] = "Debit Card Pay In";
  Feature["InstantTransfer"] = "Instant Transfer";
  Feature["RecommendChecking"] = "Recommend Checking";
  Feature["StandardTransfer"] = "Standard Transfer";
  Feature["TransferIn"] = "Transfer In";
  Feature["TransferOut"] = "Transfer Out";
  return Feature;
}({});
export let Page = /*#__PURE__*/function (Page) {
  Page["ConfigureDetails"] = "Configure Details";
  Page["ConfirmDetails"] = "Confirm Details";
  Page["Homepage"] = "Homepage";
  Page["Overview"] = "Overview";
  Page["TransferComplete"] = "Transfer Complete";
  Page["TransferError"] = "Transfer Error";
  return Page;
}({});
export let Target = /*#__PURE__*/function (Target) {
  Target["AddMoney"] = "Add Money";
  Target["CheckingOnboarding"] = "Checking Onboarding";
  Target["DismissBanner"] = "Dismiss Banner";
  Target["InstantTransfer"] = "Instant Transfer";
  Target["StandardTransfer"] = "Standard Transfer";
  Target["SubmitTransfer"] = "Submit Transfer";
  Target["TransferToBank"] = "Transfer To Bank";
  return Target;
}({});
export function getAppletFromSource(source) {
  switch (source) {
    case 'Homepage':
      return Applet.Homepage;
    case 'Transfer Settings':
      return Applet.TransferSettings;
    case 'Balance Overview':
      return Applet.Balance;
    default:
      return Applet.Banking;
  }
}
const getEventName = (action, feature) => `${action} ${feature}`;
export function getEvent(args) {
  return {
    name: getEventName(args.action, args.feature),
    properties: {
      ...args
    }
  };
}